import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, role }) {
    const { user, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="w-10 h-10 border-4 border-[#FF3B30] border-t-transparent animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    const allowed = Array.isArray(role) ? role : [role];
    if (role && !allowed.includes(user.role)) {
        const home = ["admin", "superadmin"].includes(user.role) ? "/admin" : "/operator";
        return <Navigate to={home} replace />;
    }
    return children;
}
